export function openLink(url: string) {
    window.open(url, '_blank');
}
